// Import Swiper core module.
import Swiper from 'swiper';

// Import Swiper modules.
// eslint-disable-next-line import/no-unresolved
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';

// Configure Swiper to use modules.
Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);

// Assign Swiper to window so Alpine can call on Swiper.
window.Swiper = Swiper;
